export const events = {
  logActivityVisits: 'Log activity visits',
  filter: 'Filter activity log',
}
